import { all } from "redux-saga/effects";

//public
import AccountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import LayoutSaga from "./layout/saga";

//Company
import Company from "./company/saga";

//User
import User from "./users/saga";

//SystemUser
import SystemUser from "./systemusers/saga";

//Profile
import Profile from "./profiles/saga";

//Group
import Group from "./groups/saga";

//Department
import Department from "./departments/saga";

//Skill
import Skill from "./skills/saga";

//Role
import Role from "./roles/saga";

//Edit Profile
import EditProfile from "./editprofile/saga";

//Insights
import Insights from "./insights/saga";

//ClientSystemsVariables
import ClientSystems from "./clientsystemsvariables/saga";

//SystemVariables
import ClientSystemVariables from "./systemvariables/saga";

export default function* rootSaga() {
  yield all([
    //public
    AccountSaga(),
    AuthSaga(),
    ForgetSaga(),
    LayoutSaga(),
    Company(),
    User(),
    SystemUser(),
    Profile(),
    Group(),
    Department(),
    Skill(),
    Role(),
    EditProfile(),
    Insights(),
    ClientSystems(),
    ClientSystemVariables(),
  ]);
}
